module.exports = __webpack_public_path__ + "media/images/version_merge/load_app_girl-5f58a2b44150d8f9b2c94492ed71a9a7.png";